export default __webpack_public_path__ + "static/media/Info_Recogido_por_la_transportadora_CON_recaudo_Envío_Contra_Entrega.b2f68462.png";